<app-popup
  [heading]="'New Message'"
  [confirmText]="'Send'"
  [cancelText]="'Cancel'"
  (confirmClicked)="onSendEmail()"
  (cancelClicked)="onCancelComposing()"
>
  <div class="compose-form">
    <div class="form-row to-field-row">
      <div class="to-field-container" (appClickOutside)="closeDropdown()">
        <div class="to-field-header">
          <label class="to-label" for="user-search">To:</label>
          <input
            type="text"
            id="user-search"
            class="search-input"
            placeholder="Search connections..."
            (input)="onSearchUser($event)"
            (focus)="isUsersDropdownOpen = true"
          />
          @if (isUsersDropdownOpen) {
            <button
              type="button"
              class="dropdown-toggle"
              (click)="closeDropdown()"
              title="Close dropdown"
            >
              <svg
                width="16px"
                height="16px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </button>
          }
        </div>

        @if (
          getSelectedConnections().length > 0 || getSelectedUsers().length > 0
        ) {
          <div class="selected-tags-section">
            <div class="tags-wrapper">
              @for (connection of getSelectedConnections(); track connection) {
                <div class="tag-item">
                  <span class="tag-text">{{ connection }}</span>
                  <button
                    type="button"
                    class="remove-tag-btn"
                    (click)="removeConnection(connection)"
                    title="Remove {{ connection }}"
                  >
                    <svg
                      width="12px"
                      height="12px"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                    >
                      <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                      />
                    </svg>
                  </button>
                </div>
              }
              @for (user of getSelectedUsers(); track user) {
                <div class="tag-item">
                  <span class="tag-text">{{ user }}</span>
                  <button
                    type="button"
                    class="remove-tag-btn"
                    (click)="removeUser(user)"
                    title="Remove {{ user }}"
                  >
                    <svg
                      width="12px"
                      height="12px"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                    >
                      <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                      />
                    </svg>
                  </button>
                </div>
              }
            </div>
          </div>
        }

        @if (composeErrors.to) {
          <div class="error-message">{{ composeErrors.to }}</div>
        }

        @if (isUsersDropdownOpen) {
          <div class="users-list-dropdown">
            <div class="users-list">
              <div class="users-data-list-wrapper">
                @if (!isLoadingConnections) {
                  @for (
                    connection of availableConnections;
                    track connection.id
                  ) {
                    <div class="connection-group">
                      <div class="checkbox-section company-checkbox">
                        <label class="checkbox-container">
                          <input
                            type="checkbox"
                            [(ngModel)]="
                              connectionCheckboxState[
                                connection.connection_name
                              ]
                            "
                            (change)="
                              onUsersSelection($event, connection, true)
                            "
                          />
                          <span class="checkmark"></span>
                        </label>
                        <div
                          class="label-text company-name"
                          [title]="connection.connection_name"
                          (click)="onSelectConnection(connection)"
                          (keydown.enter)="onSelectConnection(connection)"
                          tabindex="0"
                        >
                          <span>
                            {{
                              connection.display_name === ""
                                ? connection.connection_name
                                : connection.display_name
                            }}
                          </span>
                          <span
                            class="expand-icon"
                            [class.expanded]="
                              selectedConnection?.id === connection.id
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              width="12"
                              height="12"
                              fill="currentColor"
                            >
                              <path
                                d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>

                      @if (selectedConnection?.id === connection.id) {
                        @if (isLoadingConnectionUsers) {
                          <div class="loading-users">Loading users...</div>
                        } @else {
                          @if (availableUsers.length > 0) {
                            <div class="connection-users">
                              @for (user of availableUsers; track user.id) {
                                <div
                                  class="checkbox-section"
                                  [class.disabled]="
                                    selectedThroughConnections.has(
                                      user.username
                                    )
                                  "
                                >
                                  <label class="checkbox-container">
                                    <input
                                      type="checkbox"
                                      [checked]="
                                        selectedPeopleToShare.includes(
                                          user.username
                                        ) ||
                                        selectedThroughConnections.has(
                                          user.username
                                        )
                                      "
                                      [disabled]="
                                        selectedThroughConnections.has(
                                          user.username
                                        )
                                      "
                                      (change)="
                                        onUsersSelection(
                                          $event,
                                          undefined,
                                          false,
                                          {
                                            username: user.username,
                                            name: user.name,
                                          }
                                        )
                                      "
                                    />
                                    <span class="checkmark"></span>
                                    <div class="label-text" [title]="user.name">
                                      {{ user.name }}
                                    </div>
                                  </label>
                                </div>
                              }
                            </div>
                          } @else {
                            <div class="no-results users-no-results">
                              No users found.
                            </div>
                          }

                          @if (hasMoreUsers) {
                            <div class="load-more-wrapper users-load-more">
                              <button
                                type="button"
                                class="load-more-btn"
                                (click)="loadMoreUsers()"
                                [disabled]="isLoadingMoreUsers"
                              >
                                @if (isLoadingMoreUsers) {
                                  <span>Loading...</span>
                                } @else {
                                  <span>Load More</span>
                                }
                              </button>
                            </div>
                          }
                        }
                      }
                    </div>
                  } @empty {
                    <div class="no-results">No connections found!</div>
                  }
                  @if (hasMoreConnections) {
                    <div class="load-more-wrapper">
                      <button
                        type="button"
                        class="load-more-btn"
                        (click)="loadMoreConnections()"
                        [disabled]="isLoadingMoreConnections"
                      >
                        @if (isLoadingMoreConnections) {
                          <span>Loading...</span>
                        } @else {
                          <span>Load More</span>
                        }
                      </button>
                    </div>
                  }
                } @else {
                  <div class="no-results">Loading connections...</div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <fieldset class="form-row">
      <legend class="form-label">Announcement Type:</legend>
      <div
        class="announcement-type-checkboxes"
        aria-labelledby="announcementTypeLabel"
      >
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="emailChecked"
            (ngModelChange)="onTypeCheckboxChange()"
          />
          <span>Email</span>
        </label>
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="notificationChecked"
            (ngModelChange)="onTypeCheckboxChange()"
          />
          <span>Notification</span>
        </label>
      </div>
      @if (composeErrors.type) {
        <div class="error-message">{{ composeErrors.type }}</div>
      }
    </fieldset>

    <div class="form-row subject-field">
      <label class="form-label" for="subject"> Subject/Title: </label>
      <input
        type="text"
        id="subject"
        class="form-input"
        [(ngModel)]="newEmail.subject"
        (ngModelChange)="validateSubject()"
        [placeholder]="'Enter subject or title here...'"
      />
      @if (composeErrors.subject) {
        <div class="error-message">{{ composeErrors.subject }}</div>
      }
    </div>
    <div class="form-row">
      <label class="form-label" for="message">Message:</label>
      <quill-editor
        [(ngModel)]="newEmail.message"
        [modules]="quillConfig"
        [styles]="{ height: '250px' }"
      ></quill-editor>
    </div>
  </div>
</app-popup>
